export default () => ({
    from: "",
    to: "",
    message: "",
});
